<template>
  <div class="news">
    <div class="news-top">
      <div class="news-top-left">
        <div class="title">新闻中心</div>
        <div class="titleEn">News center</div>
      </div>
      <div class="news-top-right">
        <span>全部</span>
        <span>最新热点</span>
        <span>公司动态</span>
        <span>社会新闻</span>
        <img :src="iconRight2" />
      </div>
    </div>
    <div class="news-content">
      <div class="news-content-left" @click="tarDetail(leftData)">
        <div class="date">{{ leftData.date2 }}</div>
        <div class="title">{{ leftData.title }}</div>
        <div class="content">
          {{ leftData.dataList[0].value }}
        </div>
        <div class="img imgBox">
          <img :src="imgNews" />
        </div>
        <div class="more">了解更多<img :src="iconRight3" /></div>
      </div>
      <div class="news-content-right">
        <div
          class="box"
          v-for="(item, i) in newsList"
          :key="i"
          @click="tarDetail(item)"
        >
          <div class="box-top">
            <div class="box-top-title">{{ item.title }}</div>
            <div class="box-top-date">{{ item.date2 }}</div>
          </div>
          <div class="box-content">{{ item.dataList[0].value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iconRight2 from "@/assets/img/icon_right2.png";
import iconRight3 from "@/assets/img/icon_right3.png";
import imgNews from "@/assets/img/img_news.png";
import {
  data1,
  data2,
  data3,
  data4,
} from "@/components/pageDetail/config/newsConfig";
export default {
  name: "homeNews",
  data() {
    return {
      iconRight2,
      iconRight3,
      imgNews,
      leftData: data1,
      newsList: [data2, data3, data4],
    };
  },
  methods: {
    tarDetail(item) {
      this.$router.push({
        path: "/newsDetail",
        query: { type: item.type },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.news {
  padding: 156px 260px 108px 260px;
  &-top {
    display: flex;
    justify-content: space-between;
    &-left {
      .title {
        font-size: 24px;
      }
      .titleEn {
        margin-top: 10px;
        font-size: 24px;
        color: #999;
      }
    }
    &-right {
      span {
        margin-right: 58px;
        font-size: 15px;
      }
      img {
        width: 12px;
        height: 12px;
      }
    }
  }
  &-content {
    display: flex;
    justify-content: space-between;
    margin-top: 66px;
    &-left {
      width: 632px;
      cursor: pointer;
      .date {
        text-align: right;
        width: 100%;
        border-bottom: 2px solid #004f6a;
        color: #004f6a;
        font-size: 18px;
        line-height: 36px;
      }
      .title {
        font-size: 20px;
        color: #004f6a;
        margin-top: 40px;
      }
      .content {
        margin-top: 10px;
        font-size: 15px;
        color: #666;
        line-height: 28px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .img {
        margin-top: 25px;
        height: 206px;
        width: 100%;
        overflow: hidden;
        // img {
        //   width: 100%;
        //   height: 100%;
        //   transition: all 0.25s ease-in;
        // }

        // img:hover {
        //   transform: scale(1.1, 1.1);
        //   transition: all 0.25s ease-in;
        // }
      }
      .more {
        margin-top: 24px;
        display: flex;
        justify-content: end;
        align-items: center;
        color: #004f6a;
        font-size: 15px;
        img {
          width: 12px;
          height: 12px;
          margin-left: 5px;
        }
      }
    }
    &-right {
      width: 632px;
      .box {
        border-bottom: 1px solid #e7e7e7;
        height: 87px;
        cursor: pointer;
        margin-top: 70px;
        &-top {
          display: flex;
          justify-content: space-between;
          transform: translateY(0);
          transition: all 0.36s ease;
          transition-delay: 0.2;
          &-title {
            font-size: 16px;
          }
          &-date {
            font-size: 16px;
            color: #666;
          }
        }
        &-content {
          opacity: 0;
          font-size: 15px;
          line-height: 28px;
          color: #666;
          padding-top: 10px;
          transform: translateY(0);
          transition: all 0.36s ease;
          transition-delay: 0.2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .box:last-child {
        border: none;
      }
      .box:hover {
        .box-top {
          transition: all 0.36s ease;
          transform: translateY(-50px);
          transition-delay: 0.2;
        }
        .box-top-title {
          color: #004f6a;
        }
        .box-content {
          opacity: 1;
          transition: all 0.36s ease;
          transform: translateY(-50px);
          transition-delay: 0.2;
        }
      }
    }
  }
}
</style>